import * as Yup from "yup";
import {
  AADHAR_VALIDATION,
  ALPHABETS_ONLY,
  ALPHABETS_ONLY_Msg,
  APPINCODE,
  Aadhaar_Msg,
  AddresRemarks,
  Addres_Msg,
  ERROR_MSG,
  MOBILE_VALIDATION,
  Mobile_Msg,
  PINCODE,
} from "./RegularExpAndVar";
import { validateVerhoeff } from "../CommonFunctions/ValidAadhaarFunction";
import moment from "moment";

export function getMinimumEligibleDOB({
  caste, isEws, isPh, isExServiceMen}) {
  const cutoffDate = moment("2025-07-01");
  let maxAge = 45; 
  if (isPh === "true") {
    maxAge = 52;
  } else if (
    [
      "ST","SC","SC-A","SC-B","SC-C", "SC-GR I",
      "SC-GR II","SC-GR III","BC-A","BC-B","BC-C","BC-D","BC-E"
    ].includes(caste) ||
    isEws === "true"
  ) {
    maxAge = 50;
  } else if (isExServiceMen === "true") {
    maxAge = 45;
  }
  return moment(cutoffDate).subtract(maxAge, "years");
}
const today = moment();
const minAge = 18;
const maxAge = 65;
export const regValidationSchema = Yup.object()
  .shape({
    aadhaarNo: Yup.string()
      .required(ERROR_MSG)
      .matches(AADHAR_VALIDATION, Aadhaar_Msg)
      .test("isValid", Aadhaar_Msg, function (value) {
        if (value) {
          return validateVerhoeff(value);
        }
        return true;
      }),
    applicantName: Yup.string()
      .required(ERROR_MSG)
      .nullable()
      .matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
      surName: Yup.string()
      .required(ERROR_MSG)
      .nullable()
      .matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
    mobileNo: Yup.string()
      .required(ERROR_MSG)
      .nullable()
      .matches(MOBILE_VALIDATION, Mobile_Msg),
    fatherName: Yup.string()
      .required(ERROR_MSG)
      .nullable()
      .matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
    motherName: Yup.string()
      .required(ERROR_MSG)
      .nullable()
      .matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
    gender: Yup.string().required(ERROR_MSG),
    maritalStatus: Yup.string().required(ERROR_MSG),
    caste: Yup.string().required(ERROR_MSG),
    subCasteCode: Yup.string().required(ERROR_MSG),
    isEws: Yup.string().when("caste", {
      is: (caste) => caste === "OC",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
    typeOfStudy: Yup.string().required(ERROR_MSG).nullable(),
    district1: Yup.string().required(ERROR_MSG).nullable(),
    district2: Yup.string().required(ERROR_MSG).nullable(),
    district3: Yup.string().required(ERROR_MSG).nullable(),
    district4: Yup.string().required(ERROR_MSG).nullable(),
    district5: Yup.string().required(ERROR_MSG).nullable(),
    district6: Yup.string().required(ERROR_MSG).nullable(),
    district7: Yup.string().required(ERROR_MSG).nullable(),
    localDistCode: Yup.string().required(ERROR_MSG).nullable(),

    // ********For dsc ******************
  dob: Yup.date().required(ERROR_MSG)
  .test('validDob', 'Age not within allowed limits as per G.O', function (value) {
    if (!value) return true;
    const { caste, isEws, isPh, isExServiceMen } = this.parent;
    const cutoffDate = moment('2025-07-01');

    const maxDOB = moment(cutoffDate).subtract(18, 'years'); // 01-07-2007
    if (moment(value).isAfter(maxDOB)) {
      return this.createError({ message: 'Must be at least 18 years as on 01-07-2025' });
    }
    const minDOB = getMinimumEligibleDOB({caste, isEws, isPh, isExServiceMen});
    if (moment(value).isBefore(minDOB)) {
      return this.createError({
        message: `Age exceeds maximum limit as per G.O`
      });
    } return true;
  }).max(moment('2007-07-01').format('YYYY-MM-DD'), 'Must be at least 18 years as on 01-07-2025'),

    // ********For dsc upto above ******************
    // dob: Yup.date()
    //   .required(ERROR_MSG)
    //   .test('validDob', 'Invalid dob', function (value) {
    //     if (!value) return true;

    //     const { caste, isEws, isPh, isExServiceMen, exService } = this.parent;
    //     const cutoffDate = moment('2024-07-01');
    //     const minAgeDate = moment(cutoffDate).subtract(18, 'years'); // Must be 18+ as of 01-Jul-2024

    //     if (moment(value).isAfter(minAgeDate, 'day')) {
    //       return false; // Underage
    //     }

    //     let baseMaxDOB;

    //     // Default DOB cutoff by caste
    //     if (isPh === 'true') {
    //       baseMaxDOB = moment('1970-07-01');
    //     } else if (
    //       ['ST', 'SC', 'SC-A', 'SC-B', 'SC-C', 'BC-A', 'BC-B', 'BC-C', 'BC-D', 'BC-E'].includes(caste) ||
    //       isEws === 'true'
    //     ) {
    //       baseMaxDOB = moment('1975-07-01');
    //     } else if (caste === 'OC') {
    //       baseMaxDOB = moment('1980-07-01');
    //     }

    //     // If ex-serviceman, apply relaxation
    //     if (isExServiceMen === 'true') {
    //       const serviceYears = parseInt(exService || 0, 10);
    //       const totalRelaxation = serviceYears + 3;

    //       // Adjust DOB by subtracting relaxation
    //       baseMaxDOB = baseMaxDOB?.subtract(totalRelaxation, 'years');
    //     }

    //     // Final check
    //     return baseMaxDOB && moment(value).isBetween(baseMaxDOB, cutoffDate, 'day', '[]');
    //   })
    //   .max(moment('2006-07-01').format('YYYY-MM-DD'), 'Invalid dob - Must be 18+ years as of 01.07.2024'),
    email: Yup.string()
      .required(ERROR_MSG).nullable()
      .email("Invalid email address"),
    doorNo: Yup.string().required(ERROR_MSG).nullable(),
    // pinCode: Yup.string()
    //   .matches(APPINCODE, "Enter a valid PIN code")
    //   .length(6, "PIN code must be exactly 6 digits")
    //   .required(ERROR_MSG)
    //   .nullable(),
    pinCode: Yup.string()
  .required(ERROR_MSG)
  .nullable()
  .when("isAndhra", {
    is: "true",
    then: (schema) =>
      schema
        .matches(APPINCODE, "Enter valid AP PIN code (should start with 5)")
        .length(6, "PIN code must be exactly 6 digits"),
    otherwise: (schema) =>
      schema
        .matches(PINCODE, "Enter valid PIN code")
        .length(6, "PIN code must be exactly 6 digits"),
  }),
    address: Yup.string().required(ERROR_MSG)
      .nullable()
      .matches(AddresRemarks, Addres_Msg),
    isExServiceMen: Yup.string().required(ERROR_MSG),
    // exService: Yup.string().when("isExServiceMen", {
    //   is: (isNative) => isNative === "true",
    //   then: Yup.string().required(ERROR_MSG),
    //   oterwise: Yup.string(),
    // }),

exService: Yup.string().when("isExServiceMen", {
  is: (val) => val === "true",
  then: Yup.string()
    .required(ERROR_MSG)
    .test("max-exp-check",
      "Experience exceeds allowed limit based on DOB",
      function (value) {
        const { dob } = this.parent;

        if (!value || !dob) return true;

        const age = moment().diff(moment(dob), "years");

        let maxExp = age >= 18 ? age - 18 : 0;
        if (maxExp > 13) maxExp = 13;

        return Number(value) <= maxExp; 
      }
    ),
  otherwise: Yup.string(),
}),
    isPh: Yup.string().required(ERROR_MSG),
    selfCheck: Yup.boolean().oneOf([true], ERROR_MSG),
    vhPercentage: Yup.string().when("isVh", {
      is: (isNative) => isNative === true,
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
    hiPercentage: Yup.string().when("isHi", {
      is: (isNative) => isNative === true,
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
    ohPercentage: Yup.string().when("isOh", {
      is: (isNative) => isNative === true,
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
    miPercentage: Yup.string().when("isMi", {
      is: (isNative) => isNative === true,
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
    isAndhra: Yup.string().required(ERROR_MSG),
    state: Yup.string().when("isAndhra", {
      is: (isNative) => isNative === "false",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
    district: Yup.string().when("isAndhra", {
      is: "false",
      then: Yup.string()
        .required(ERROR_MSG)
        .matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
      otherwise: Yup.string().required(ERROR_MSG),
    }),
    mandal: Yup.string().when("isAndhra", {
      is: "false",
      then: Yup.string()
        .required(ERROR_MSG)
        .matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
      otherwise: Yup.string().required(ERROR_MSG),
    }),
    village: Yup.string().when("isAndhra", {
      is: (isNative) => isNative === "true",
      then: Yup.string().required(ERROR_MSG).nullable(),
      otherwise: Yup.string().nullable(),
    }),
   isTelangana: Yup.string().when('localDistCode', {
  is: (val) => val === 999,
  then: (schema) => schema.required(ERROR_MSG),
  otherwise: (schema) => schema.notRequired(),
}),
    claimingDistrict: Yup.string().when("isTelangana", {
      is: (isNative) => (isNative === "true"),
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
  })
  .test("myCustomCheckboxTest", function (obj) {
    if (obj.isPh === "true") {
      if (obj.isOh || obj.isHi || obj.isMi || obj.isVh) {
        return true; // everything is fine
      }
      return new Yup.ValidationError(
        "Check at least one checkbox",
        null,
        "isMi",
      );
    }
   });

export const examCenterValidations = Yup.object().shape({
  option1: Yup.string()
    .required(ERROR_MSG)
    .test("unique", "Option  is already selected", (value, context) => {
      if (value !== "") {
        const { option2, option3, option4, option5 } = context.parent;
        return (
          value !== option2 &&
          value !== option3 &&
          value !== option4 &&
          value !== option5
        );
      }
      return true;
    }),
  option2: Yup.string()
    .required(ERROR_MSG)
    .test("unique", "Option  is already selected", (value, context) => {
      if (value !== "") {
        const { option1, option3, option4, option5 } = context.parent;
        return (
          value !== option1 &&
          value !== option3 &&
          value !== option4 &&
          value !== option5
        );
      }
      return true;
    }),
  option3: Yup.string()
    .required(ERROR_MSG)
    .test("unique", "Option  is already selected", (value, context) => {
      if (value !== "") {
        const { option2, option1, option4, option5 } = context.parent;
        return (
          value !== option2 &&
          value !== option1 &&
          value !== option4 &&
          value !== option5
        );
      }
      return true;
    }),
  option4: Yup.string()
    .required(ERROR_MSG)
    .test("unique", "Option  is already selected", (value, context) => {
      if (value !== "") {
        const { option2, option3, option5, option1 } = context.parent;
        return (
          value !== option2 &&
          value !== option3 &&
          value !== option5 &&
          value !== option1
        );
      }
      return true;
    }),
  option5: Yup.string()
    .required(ERROR_MSG)
    .test("unique", "Option  is already selected", (value, context) => {
      if (value !== "") {
        const { option2, option3, option4, option1 } = context.parent;
        return (
          value !== option2 &&
          value !== option3 &&
          value !== option4 &&
          value !== option1
        );
      }
      return true;
    }),
});
